import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SwUpdaterService } from './app-services/sw-updater.service';
import { RouterOutlet } from '@angular/router';
import { BROWSER_SCREEN } from 'app/tokens/browser.tokens';

type LockableScreenOrientation = ScreenOrientation & {
  lock(orientation: 'landscape'): Promise<void>;
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly swUpdaterService = inject(SwUpdaterService);
  private readonly browserScreen = inject(BROWSER_SCREEN);

  constructor() {
    this.iconRegistry.addSvgIconResolver((name: string): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`assets/mat-icons/${name}.svg`);
    });

    afterNextRender((): void => {
      this.swUpdaterService.alertSwUpdate();
      this.lockScreenOrientation();
    });
  }

  private lockScreenOrientation(): void {
    const orientation = this.browserScreen?.orientation;

    if (!this.canLockScreenOrientation(orientation)) {
      return;
    }

    void orientation.lock('landscape').catch(() => undefined);
  }

  private canLockScreenOrientation(orientation: ScreenOrientation | undefined): orientation is LockableScreenOrientation {
    return !!orientation && 'lock' in orientation && typeof orientation.lock === 'function';
  }
}
